<template>
  <div class="w-full h-full">

    <template v-if="$address">
      <template v-if="!loading">
        <div v-if="eligible?.includes('view')" class="w-full h-full flex flex-col justify-start items-start min-h-screen">
          <OTCBanner :project_banner="project.project_banner" :project_name="project.project_name"
            :project_logo="project.project_logo" :project_id="project.project_id"
            :project_description="project.project_description"></OTCBanner>

          <nav
            class="w-full flex justify-start items-center bg-white/10 border-b border-b-white/5 p-2 gap-2">

            <button @click="selectTab(tab)" v-for="tab in tabs"
              :class="['text-left p-2 xl:px-4 xl:p-2 capitalize tracking-widest rounded-md flex justify-center xl:justify-start xl:flex-row flex-col items-center xl:space-x-2 duration-200 flex-shrink-0', tab.selected ? 'bg-white/10 text-turquoise-500' : 'hover:bg-white/5 text-woodsmoke-200 ']">
              <Icon class="xl:text-2xl text-xl mb-1" :name="tab.icon"></Icon>
              <div class="xl:block hidden text-base">{{ tab.name }}</div>
              <div class="text-3xs xl:hidden">{{ tab.shortName }}</div>
            </button>

            <div class="xl:w-full w-min h-full flex justify-end items-center">
              <OTCNewListingModal v-if="eligible?.includes('list')" :pools="allocations" @listed="handleListed()">
              </OTCNewListingModal>
            </div>

            <button @click="showFilter = true;" class="xl:hidden btn-sm sm:btn-md btn btn-square bg-white/5 border-none">
              <Icon class="text-sm sm:text-lg" name="icon-park-solid:filter"></Icon>

              <HeadlessTransitionRoot as="template" :show="showFilter">
                <HeadlessDialog as="div" class="relative z-50" @close="showFilter = false">
                  <div class="fixed inset-0 bg-white/30 backdrop-blur-sm" />

                  <div class="fixed inset-0 overflow-hidden">
                    <div class="absolute inset-0 overflow-hidden">
                      <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <HeadlessTransitionChild as="template"
                          enter="transform transition ease-in-out duration-500 sm:duration-700"
                          enter-from="translate-x-full" enter-to="translate-x-0"
                          leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0"
                          leave-to="translate-x-full">
                          <HeadlessDialogPanel class="pointer-events-auto w-screen max-w-md">
                            <div class="flex h-full flex-col overflow-y-scroll bg-woodsmoke-850 py-6 shadow-xl">
                              <div class="px-4 sm:px-6">
                                <div class="flex items-start justify-between">
                                  <HeadlessDialogTitle class="text-base font-semibold leading-6 text-turquoise-500">Filter
                                  </HeadlessDialogTitle>
                                  <div class="ml-3 flex h-7 items-center">
                                    <span class="absolute -inset-2.5" />
                                    <button type="button" class="relative rounded-md bg-white/10 text-red-500"
                                      @click="showFilter = false">
                                      <span class="sr-only">Close panel</span>
                                      <Icon name="eva:close-fill" class="h-6 w-6" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="relative mt-6 flex-1 px-2">
                                <OTCFilter></OTCFilter>
                              </div>
                            </div>
                          </HeadlessDialogPanel>
                        </HeadlessTransitionChild>
                      </div>
                    </div>
                  </div>
                </HeadlessDialog>
              </HeadlessTransitionRoot>


            </button>

          </nav>


          <template v-if="selectedTab.key == 'all' || selectedTab.key == 'my'">
            <div class="w-full grid grid-cols-5 flex-grow">
              <div class="xl:block hidden border-r border-r-white/10 h-full">
                <OTCFilter @filterChanged="onChangeFilter" @sortChanged="onChangeSort"></OTCFilter>
              </div>

              <div class="xl:col-span-4 col-span-full">
                <template v-if="busy">
                  <p class="p-4">Loading...</p>
                </template>
                <template v-else>
                  <div v-for="project in projects" :key="project.name"
                    class="border-t border-t-white/20 first:border-t-0">
                    <OTCProject @unlisted="handleUnlisted()" :project="project"></OTCProject>
                  </div>
                  <p class="p-4" v-if="!(projects?.length>0)">No Projects</p>
                </template>
              </div>
            </div>
          </template>

          <template v-if="selectedTab.key == 'history'">
            <OTCHistory></OTCHistory>
          </template>
        </div>
        <div v-else class="w-full sm:h-full sm:min-h-screen flex flex-col justify-center items-center">
          <div class="w-full h-full flex justify-center items-center flex-col font-light text-center px-8">
            <h1 class="text-3xl">This feature is open exlusively for Tier 1 and Private Sales Pass Holder</h1>
            <div classs="pt-12">
              <NuxtLink to="/app/stake">
                <button class="btn btn-link text-red-500">Upgrade Tier</button>
              </NuxtLink>
            </div>
          </div>
        </div>
      </template>
      <template v-else>

        <div class="w-full h-full flex flex-col justify-center items-center sm:min-h-full">
          <p>Loading...</p>

        </div>

      </template>
    </template>
    <template v-else>

      <div class="w-full h-full flex justify-center items-center flex-col font-light text-center px-8">
        <h1 class="text-3xl">Connect Wallet to Proceed</h1>

        <WalletModal>
          <button class="btn bg-turquoise-600 mt-4 text-black hover:text-white">Connect Wallet</button>
        </WalletModal>

        <div class="pt-12">
          <NuxtLink to="/app">
            <button class="btn btn-link text-red-500">return to home</button>
          </NuxtLink>
        </div>
      </div>

    </template>

  </div>
</template>

<script setup>

// import { config } from "~/wagmiConfig.js";
// import { getAccount, watchConnections, disconnect } from "@wagmi/core";

// const address = ref("");

const toast = useToast();
const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};


// const unwatch = watchConnections(config, {
//   onChange(data) {
//     if (data) {
//       let _account = getAccount(config);
//       address.value = _account.address;
//     } else {
//       address.value = null;
//     }
//   },
// });

// onUnmounted(() => {
//   unwatch();
// });

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

const { $address, $accessToken } = useNuxtApp()

definePageMeta({
  layout: "app",
  name: "otc",
});

const tabs = ref([
  { name: "All Listings", icon: "iconamoon:shopping-bag-duotone", selected: true, key: "all", shortName: "All" },
  { name: "My Listings", icon: "ic:twotone-person", selected: false, key: "my", shortName: "My Listings" },
  { name: "History", icon: "iconamoon:history-duotone", selected: false, key: "history", shortName: "History" },
]);

const eligible = ref(false)
const showFilter = ref(false);

//const project = {
//  project_banner: "https://picsum.photos/300/400",
//  project_logo: "https://picsum.photos/200/200",
//  project_name: "Project Name",
//  project_id: "kwai",
//  project_description: "lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//}

const loading = ref(true);
const busy = ref(false);

const project = ref({})
const allocations = ref([])
const selectedTab = computed(() => tabs.value.find(t => t.selected))

const selectTab = (tab) => {
  tabs.value.forEach(t => t.selected = tab.key == t.key)
  switch (tab.key) {
    case "all":
    case "my":
      renderPools()
      break
    case "history":
      break

  }
}

const projects = ref([])

// dummy spawn projects

//for (let i = 0; i < 10; i++) {
//  projects.value.push({
//    "name": "Project Name",
//    "status": "concluded",
//    "logo": "https://picsum.photos/200/200",
//    "pools": [
//      {
//        "name": "Pool Name",
//        "oversub": true,
//        "listings": [
//          {
//            "price": 100,
//            "currency": "USDT",
//            "allocation": 150,
//            "owner": "0x5A7fD850e62A264172ecD332F2A926a9E32fF436",
//            "active": true,
//            "is_owner": true
//          }
//        ]
//      }
//    ]
//  })
//}

// dummy spawn listings

//for (let i = 0; i < 10; i++) {
//  projects.value[0].pools[0].listings.push({
//    "price": 100,
//    "currency": "USDT",
//    "allocation": 150,
//    "owner": "0x5A7fD850e62A264172ecD332F2A926a9E32fF436",
//    "active": true,
//    "is_owner": false
//  })
//}


//const config = createConfig({
//    chains: [bsc, mainnet, arbitrum],
//    connectors: [walletConnectConnector, injected()],
//    client({ chain }) {
//        return createClient({ chain, transport: http() })
//    },
//})


async function handleListed() {
  userStore.loading = true;
  return Promise.all([
    renderPools(),
    renderAllocation(),
  ])
    .then(() => {
      userStore.loading = false;
      _toast({
        id: "listed",
        title: "Success",
        description: "Successfully Listed",
        timeout: 5000,
      });
    })
    .catch(err => {
      userStore.loading = false;
      console.error(err)
      _toast({
        id: "list_error",
        title: "Fail",
        description: "Unable To List!",
        timeout: 5000,
      });
    })


}
async function handleUnlisted() {
  userStore.loading = true;
  return Promise.all([
    renderPools(),
    renderAllocation(),
  ])
    .then(() => {
      _toast({
        id: "unlisted",
        title: "Success",
        description: "Successfully Unlisted!",
        timeout: 5000,
      });
      userStore.loading = false;
    })
    .catch(err => {
      console.error(err)
      _toast({
        id: "unlist_error",
        title: "Fail",
        description: "Unable To Unlist!",
        timeout: 5000,
      });
      userStore.loading = false;
    })

}

async function checkPermission() {
  try{
    let res = await $fetch(`/api/permission?target=otc`, {
      headers: {
        'Authorization': `Bearer ${$accessToken.value}`
      }
    })
    eligible.value = res.eligible
  }catch(err){
    console.error(err)
  }
}

async function renderPools(params) {

  busy.value = true
  projects.value = []

  if (!params) {
    params = new URLSearchParams()
  }
  params.append('view', selectedTab.value.key)
  if ($accessToken.value) {

    if (!eligible.value)
      await checkPermission()

    if (eligible.value?.includes("view")) {
      const result = await $fetch(`/api/otc/list?${params.toString()}`, {
        headers: {
          'Authorization': `Bearer ${$accessToken.value}`
        }
      })

      projects.value = result;

      if (result?.length > 0) {
        const firstProject = result[0]
        project.value = {
          project_banner: firstProject.banner,
          project_logo: firstProject.logo,
          project_name: firstProject.name,
          project_id: firstProject.project_id,
          project_description: firstProject.description,
        }

      }
    }


    loading.value = false

  }

  busy.value = false
}

async function renderAllocation() {
  //let _account = getAccount(config);

  if ($accessToken.value) {
    const result = await $fetch("/api/otc/allocations", {
      headers: {
        Authorization: `Bearer ${$accessToken.value}`,
      },
    });
    allocations.value = result.allocations;
  }
}


async function onChangeSort(e) {
  let params = new URLSearchParams()
  e.value.map(sort => {
    const val = sort.value + "." + sort.ascending
    params.append("sort", val)
    //if (f.selected) {
    //  params.append(sort.name.toLowerCase(), f.value)
    //}

  })

  return renderPools(params)
}

async function onChangeFilter(e) {
  let params = new URLSearchParams()
  e.value.map(filter => {
    //switch (filter.name) {
    //case "Tier": {
    filter.filters.map(f => {
      if (f.selected) {
        params.append(filter.name.toLowerCase(), f.value)
      }
    })
    //} }

  })

  return renderPools(params)
}

// const unsub = userStore.$subscribe((state) => {
//   renderPools();
//   renderAllocation()
// });



let throttled = false;

const renderView = () => {
  let main = () => {
    renderPools();
    renderAllocation()
  }

  if(throttled) {
    clearTimeout(throttled)
  }

  throttled = setTimeout(main, 1000)
}

let addressWatch, accessTokenWatch;

onMounted(() => {
  
  // let _account = getAccount(config);
  // address.value = _account.address;
  renderView();

  addressWatch = watch($address, () => {
    renderView();
  })

  accessTokenWatch = watch($accessToken, () => {
    renderView();
  })
});

onBeforeRouteLeave(() => {
  addressWatch();
  accessTokenWatch();
})

// onUnmounted(() => {
//   unsub();
// });

//TODO: markup price should deduct platform fee
</script>

<style></style>